import React, { createContext, useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { monthRange } from '../../../components/dateRange';
import { fetchComplianceCentre } from '../../../features/complianceCentre/complianceCentreActions';

const ComplianceCentreContext = createContext(null);
export function ComplianceCentreProvider({ children }) {
  const dispatch = useDispatch();
  const [range, setRange] = useState(monthRange);
  const [refreshKey, setRefreshKey] = useState(0);
  const [panel, setPanel] = useState(null);
  const state = useSelector(store => store.complianceCentre);
  useEffect(() => {
    const request = dispatch(fetchComplianceCentre(range));
    return () => request.abort();
  }, [dispatch, range, refreshKey]);
  const data = state.data?.range?.startDate === range.startDate && state.data?.range?.endDate === range.endDate ? state.data : null;
  const loading = state.loading || (!state.error && !data);
  const emptyMessage = text => loading ? 'Loading…' : state.error ? 'Unable to load records.' : text;
  return <ComplianceCentreContext.Provider value={{ data, range, setRange, selectedDate: range.endDate, loading, error: state.error,
    refresh: () => setRefreshKey(value => value + 1), panel, setPanel, emptyMessage }}>
    {children}
  </ComplianceCentreContext.Provider>;
}
export function useComplianceCentre() {
  const context = useContext(ComplianceCentreContext);
  if (!context) throw new Error('useComplianceCentre must be used inside ComplianceCentreProvider');
  return context;
}
